<template>
  <q-btn
          v-if="isGranted('EDIT_USER', user)"
          icon="fa fa-pencil-alt"
          title="Edit user"
          v-bind="$attrs"
          @click="openModal" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import isGranted from '@/auth/isGranted';
import { User } from '@/type';
import openModal from '@/components/modal';
import EditUserModal from '@/user/EditUserModal.vue';

export default defineComponent({
  emits: ['saved'],
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { user: _.cloneDeep(this.user) };
      openModal(EditUserModal, props).onOk((user: User) => {
        this.$emit('saved', user);
      });
    },
    isGranted,
  },
});
</script>
